import { useCallback, type FC } from 'react';
import { useSelector } from 'react-redux';

import { type LString, t, T } from '@web-solutions/module-localization';
import { selectNoFundsOfferProducts } from '@web-solutions/core/store/billing/selectors';
import { Title, Text } from '@web-solutions/core/ui-elements';

import { SpecialOfferBase } from '../special-offer-base'
import { tKey } from '../constants';
import type { SpectialOfferTypeProps } from '../types'

import { ProductItem, Timer } from './components'
import styles from './style.module.scss';

interface SpecialOfferNoFundsProps extends Omit<SpectialOfferTypeProps, 'activeProduct' | 'onGetClick'> {
  discount: number,
  activeProductIndex: number
  onGetClick: (productId: string) => void
  currentPriceText?: LString
}

export const SpecialOfferNoFunds: FC<SpecialOfferNoFundsProps> = ({
  isOpen,
  discount,
  buttonTitle,
  activeProductIndex,
  currentPriceText,
  onGetClick,
  onClose,
}) => {
  const noFundsOfferProducts = useSelector(selectNoFundsOfferProducts);

  const activeProduct = noFundsOfferProducts[activeProductIndex] ?? noFundsOfferProducts[0]

  const handleOnGetClick = useCallback(() => onGetClick(activeProduct?.id), [activeProduct?.id, onGetClick])

  return (
    <SpecialOfferBase
      mode='no_funds'
      withPaymentDescription
      isOpen={isOpen}
      className={styles.modalContainer}
      activeProduct={activeProduct}
      buttonTitle={buttonTitle}
      onClose={onClose}
      onGetClick={handleOnGetClick}
    >
      <div className={styles.wrapper}>
        <Text className={styles.error}>
          {t(`${tKey}.no_funds.error`)}
        </Text>
        <Text className={styles.description}>
          {t(`${tKey}.no_funds.description`)}
        </Text>
        <Title className={styles.title}>
          <T k={`${tKey}.no_funds.title`} tOptions={{ discount }} />
        </Title>
        {activeProduct && <ProductItem currentPriceText={currentPriceText} activeProduct={activeProduct} />}
        <Text className={styles.timeLeft}>
          <T k={`${tKey}.no_funds.time_left`} tOptions={{ discount }} />
        </Text>
        <Timer />
      </div>
    </SpecialOfferBase>
  )
}

